import React from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';
import PageTemplate from '../../../components/common/template/PageTemplate';
import { Text } from '../../../components/common/atom/Text';
import { Button } from '../../../components/common/atom/Button';
import * as PATH from '../../../lib/routes/path';

const formatDateTime = (str) => str.replace('T', ' ').substring(0, str.length - 3);

const HeRecordingView = ({ data: recordings }) => {
  const history = useHistory();
  
  const viewRecording = (recording) => {
    history.push({
      pathname: `${PATH.HE_RECORDING}/${recording.id}`,
      state: { recording },
    })
  }

  if (recordings.length === 0) {
    return (
      <PageTemplate title={PAGE_TITLE_UPLOADING}>
        <div style={{ marginBottom: '1.5rem' }}>
          <Text size={16} lineHeight={1.5}>
            방사선사 선생님이 정성을 다해 태아의 입체초음파 영상을 분석하고 있어요.<br /><br />
            조금만 더 기다려 주시면 초음파 동영상을 만나보실 수 있습니다.
          </Text>
        </div>
        <RefreshButton
          style={{ height: '2.595rem', marginTop: '1.25rem' }}
          onClick={() => window.location.reload()}
        >
          {REFRESH_BUTTON}
        </RefreshButton>
      </PageTemplate>
    );
  } else {
    return (
      <PageTemplate title={PAGE_TITLE_RECORD}>
        <Text size={20} weight="bold" lineHeight={1.5}>동영상 다운로드<br /></Text>
        <Text size={16} lineHeight={1.5}>초음파 동영상을 확인해보세요!</Text>
        <div style={{ padding: '0.5rem' }}>
          {recordings.map((recording, idx) => {
            if (recording.status === 'COMPLETED') {
              return (
                <FinalProductItem onClick={() => viewRecording(recording)} style={{cursor: "pointer"}} key={idx}>
                  <Text size={16} lineHeight={1.75}>{formatDateTime(recording.recordingStartDateTime)}</Text><br />
                  <Text size={16} weight="bold" lineHeight={1.75}>초음파 동영상 다운로드</Text>
                </FinalProductItem>
              )
            } else {
              return (
                <FinalProductItem key={idx}>
                  <Text size={16} color="pinkishGrey" lineHeight={1.75}>{formatDateTime(recording.recordingStartDateTime)}</Text><br />
                  <Text size={16} color="pinkishGrey" weight="bold" lineHeight={1.75}>초음파 동영상 {recording.status === "RECORDING" ? "녹화중" : "업로드 중" }</Text>
                </FinalProductItem>
              )
            }
          })}
        </div>
      </PageTemplate>
    );
  }
}

export default React.memo(HeRecordingView);

const PAGE_TITLE_UPLOADING = '초음파 동영상 업로드 중';
const PAGE_TITLE_RECORD = '초음파 동영상';
const REFRESH_BUTTON = '초음파 동영상 확인하기';

const FinalProductItem = styled.div`
  border: 1px solid #C7C7C7;
  border-radius: 5px;
  width: 19.5rem;
  padding: 1rem;
  margin: 0.625rem auto;
`

const RefreshButton = styled(Button)`
  border-radius: 0.375rem;
  background: ${(props) => props.theme.color.orangePink};
`;
